<template>
    <div class="container">
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220506/1651824829013.png" alt="">
            <img class="recevice-avatar" :src="inviterInfo.inviterHeadPic">
            <div class="recevice-name">{{ inviterInfo.inviterName }}</div>
            <div v-if="canReceive" class="recevice-btn" @click="receviceFn">立即领取</div>
            <div v-else class="recevice-btn" @click="moreVip">再得7天超级VIP</div>
        </div>
        <commonCom />
        <div v-if="receviceSuccsessVisible" class="recevice-modal">
            <div class="recevice-modal-content">
                <img class="modal-colse" @click="receviceSuccsessVisible = false" src="https://s20.lgstatic.com/growth/activity/20220506/1651819530784.png" alt="">
                <div class="title">领取成功</div>
                <div class="desc">感谢助力，7天超级VIP已发放到您</div>
                <div class="desc">{{ accountInfo }}账户</div>
                <div class="recevice-btn" @click="moreVip">再得7天超级VIP</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { Toast } from 'vant';
import { preReceiveVip, receiveVip, getInviter } from '../../../service/api'
import commonCom from './commonCom.vue'
export default {
    components: {
        commonCom
    },
    data() {
        return {
            receviceSuccsessVisible: false,
            inviteNo: '',
            inviterInfo: {},
            canReceive: true,
            accountInfo: ''
        }
    },
    created () {
        const { inviteNo = '' } = this.$route.query;
        this.inviteNo = inviteNo;
        if (this.isLogin() || this.isApp) {
            this.preReceiveVip();
        }
        this.getInviter();
    },
    methods: {
        getInviter() {
            getInviter({
                inviteNo: this.inviteNo
            }).then(res => {
                if (res.state == 1) {
                    this.inviterInfo = res.content || {};
                } else {
                    Toast(res.message);
                }
            })
        },
        preReceiveVip() {
            preReceiveVip({
                inviteNo: this.inviteNo
            }).then(res => {
                if (res.state == 1) {
                    const { content = {} } = res;
                    this.canReceive = content.canReceive || false;
                    if (content.self) {
                        window.location.replace('https://edu.lagou.com/growth/sem/confession.html');
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        receviceFn() {
            if (!this.isLogin()) {
                return window.open('/frontLogin.do', '_self');
            }
            receiveVip({
                inviteNo: this.inviteNo
            }).then(res => {
                if (res.state == 1) {
                    if (res.content.success) {
                        this.receviceSuccsessVisible = true;
                        this.accountInfo = res.content.message || '';
                        this.preReceiveVip();
                    } else {
                        Toast(res.content.message || '');
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        moreVip() {
            if (!this.isLogin()) {
                return window.open('/frontLogin.do', '_self');
            }
            window.location.href = "https://edu.lagou.com/growth/sem/confession.html";
        },
        isLogin() {
            return Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token');
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 100%;
    }
    .invite {
        position: absolute;
        left: 50%;
        bottom: 120px;
        width: 640px;
        height: 84px;
        transform: translateX(-50%);
    }
    .record {
        position: absolute;
        bottom: 70px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 26px;
        color: #fff;
        font-style: italic;
        text-decoration: underline;
    }
    .recevice-avatar {
        position: absolute;
        top: 98px;
        left: 91px;
        width: 89px;
        height: 89px;
        background: #FFFFFF;
        border: 1px solid;
        border-image: linear-gradient(0deg, #FFEDE1, #FBD1B4) 2 2;
        border-radius: 50%;
    }
    .recevice-name {
        position: absolute;
        top: 98px;
        left: 200px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #222238;
        line-height: 30px;
    }
    .recevice-btn {
        position: absolute;
        bottom: 60px;
        left: 50%;
        width: 402px;
        height: 70px;
        line-height: 70px;
        background: linear-gradient(169deg, #1E2230, #404864);
        border-radius: 35px;
        transform: translateX(-50%);
        font-size: 28px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #FFFFFF;
        text-shadow: 2px 2px 13px rgba(23, 24, 47, 0.52);
        text-align: center;
        &.receviced {
            opacity: .7;
        }
    }

}
.recevice-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    .recevice-modal-content {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 600px;
        height: 310px;
        background-color: #FF506D;
        border-radius: 5px;
        transform: translate(-50%, -50%);
    }
    .modal-colse {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 21px;
        height: 21px;
    }
    .title {
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        margin-top: 48px;
        margin-bottom: 27px;
    }
    .desc {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
    }
    .recevice-btn {
        width: 285px;
        height: 56px;
        line-height: 56px;
        border-radius: 28px;
        text-align: center;
        background: linear-gradient(177deg, #FFFFFF, #FFE5B9);
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #967442;
        margin: 34px auto 0;
    }
}

</style>
